import { render } from "./application-schema.vue?vue&type=template&id=5ec757a9"
import script from "./application-schema.vue?vue&type=script&lang=js"
export * from "./application-schema.vue?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__